module.exports = __webpack_public_path__ + "static/img/promotion2.704c4c53.png";